import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  const names = ['María', 'Lucía', 'Sofía', 'Valentina', 'Camila', 'Florencia', 'Ana', 'Julieta'];
  const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe'];
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 5000);
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setVisible(false);
        // Schedule next popup
        setTimeout(showPopup, 15000 + Math.random() * 10000);
      }, 5000);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl p-4 border-l-4 border-green-500 animate-fade-in-up max-w-xs" data-id="element-174">
      <div className="flex items-start gap-3" data-id="element-175">
        <div className="bg-green-100 rounded-full p-2" data-id="element-176">
          <CheckCircle className="w-6 h-6 text-green-600" data-id="element-177" />
        </div>
        <div data-id="element-178">
          <p className="text-sm font-bold text-gray-900" data-id="element-179">¡Nueva compra!</p>
          <p className="text-sm text-gray-600" data-id="element-180">
            <span className="font-semibold" data-id="element-181">{data.name}</span> de {data.city}{' '}
            compró el{' '}
            <span className="text-blue-600 font-medium" data-id="element-182">
              Pack Cuerpo Humano
            </span>
          </p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-183">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}